// Which landing pages are the same page in another language. Each language's
// config/hubs/<locale>.json maps a page type ("voice-changer", "cover",
// "clone", "characters", "celebrities") to its slug; next.config.mjs reads the
// same files to route the slugs to pages/hub/[slug].tsx. Small and
// client-safe, unlike the page copy in config/localeHubs.
import type { Locale } from "@jammable/ui-core/src/i18n";
import en from "./hubs/en.json";
import es from "./hubs/es.json";
import pt from "./hubs/pt.json";
import fr from "./hubs/fr.json";
import de from "./hubs/de.json";
import ja from "./hubs/ja.json";
import ko from "./hubs/ko.json";
import id from "./hubs/id.json";
import tr from "./hubs/tr.json";

export const HUB_SLUGS: Record<Locale, Record<string, string>> = {
  en,
  es,
  pt,
  fr,
  de,
  ja,
  ko,
  id,
  tr,
};

const pathFor = (l: Locale, slug: string) =>
  l === "en" ? `/${slug}` : `/${l}/${slug}`;

// The page of type `group` in every language that has one, as paths.
export function hubAlternates(
  group: string | undefined,
): Partial<Record<Locale, string>> | undefined {
  if (!group) return undefined;
  const out: Partial<Record<Locale, string>> = {};
  for (const [l, groups] of Object.entries(HUB_SLUGS) as [
    Locale,
    Record<string, string>,
  ][]) {
    if (groups[group]) out[l] = pathFor(l, groups[group]);
  }
  return out;
}
